import { HTMLAttributes } from 'react'

import { useAppStore } from '@/contexts/store'

import Spinner from './spinner'
import Typography from './typography'
import { cn } from '@/lib/utils'

export type ScrollToProps = HTMLAttributes<HTMLDivElement>

const ScrollTo = ({ className, ...props }: ScrollToProps) => {
  const { strings } = useAppStore()

  return (
    <div className={cn('flex items-center space-x-[1.6rem] text-white', className)} {...props}>
      <Spinner variant="small" />
      <Typography variant="breadcrumbs" className="whitespace-nowrap font-bold">
        {strings?.labels?.scroll}
      </Typography>
    </div>
  )
}

export default ScrollTo
